<template>
    <client-page class="app--main">
        <main-visual />
        <main-efficient />
        <main-practice-areas />
        <main-attorneys />
        <main-location />

        <popup-layer />
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainLinkCard from "@/components/client/main/main-link-card.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainEfficient from "@/components/client/main/main-efficient.vue";
import MainPracticeAreas from "@/components/client/main/main-practice-areas.vue";
import MainAttorneys from '@/components/client/main/main-attorneys.vue';
import MainLocation from '@/components/client/main/main-location.vue';

export default {
    components: {
        ClientPage,
        PopupLayer,
        MainLinkCard,
        MainVisual,
        MainEfficient,
        MainPracticeAreas,
        MainAttorneys,
        MainLocation,
    },
};
</script>

<style lang="scss" scoped>
</style>
